'use strict';

const useScrollbarWidthOffset = require('../hooks/useScrollbarWidthOffset.js');

var ScrollbarWidthOffset = function ScrollbarWidthOffset(_ref) {
  var container = _ref.container;
  useScrollbarWidthOffset.useScrollbarWidthOffset(container);
  return null;
};

module.exports = ScrollbarWidthOffset;
